<template>
  <div id="app">
    <router-view></router-view>
    <!-- 1112111111123 -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { apiGetCartList } from "@/api/cart/cart";
export default {
  name: "App",
  computed: {
    ...mapGetters(["token", "userId"]),
  },
  created() {
    if (!this.token) {
      
    } else {
      apiGetCartList()
        .then((res) => {
          let { rows = [] } = res;
          let data = [];
          rows.map((item) => {
            data.push({ ...item, isCheck: false });
          });
          this.$store.dispatch("setShoppingCart", data);
        })
        .catch((err) => this.$store.dispatch("setShoppingCart", []));
    }
    let loc=location.href;
    if(loc.indexOf('/lexue-code')!=-1&&loc.indexOf('/#/lexue-code')==-1){
      let url=loc.split('#')[0]
      let list=url.split('/lexue-code')
      let codeUrl=list[0]+'/#/lexue-code'+list[1]
      window.location.replace(codeUrl)
    }
    

    setTimeout(()=>{
      this.$store.dispatch("setShoppingCart", []);
      this.$store
      .dispatch("GetUserInfo")
    },1000)
  },
};
</script>

<style lang="scss">
.xml-graph-link{
  color: #2f8ffd;
  cursor: pointer;
}
.fillInTheBlanksSpan {
  border-bottom: 1px solid #333;
}
.ql-editor .first-line {
  text-indent: 2em;
}
.theme-background-bg {
  image,
  text,
  div,
  button {
    filter: grayscale(100%);
  }
}
.topLeft {
  position: absolute;
  top: 25px;
  right: 120px;
}
div {
  word-break: break-all;
}
@font-face {
  font-family: "PingFang SC";
  src: url("../static/typeface/PingFang-Jian-ChangGuiTi-2.ttf")
    format("truetype");
}
@import url("./assets/styles/reset.css");
@import url("./assets/styles/common.css");
@import url("./assets/styles/index.scss");
// 修改滚动条样式
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  border-radius: 4px;
  background: #f2f2f2;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.3);
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.5);
}
.el-tabs {
  .el-tabs__nav-wrap::after {
    height: 1px !important;
  }
  .el-tabs__active-bar {
    height: 3px !important;
  }
}
.outtabs {
  .el-tabs__nav-wrap {
    padding: 10px 0 0 30px;
    .el-tabs__active-bar {
      width: 78px !important;
    }
    .el-tabs__item {
      text-align: center;
      span {
        width: 78px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
      }
    }
  }
}
.intabs {
  .el-tabs__nav-wrap {
    .el-tabs__active-bar {
      width: 63px !important;
    }
    .el-tabs__item {
      text-align: center;
      span {
        width: 63px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
      }
    }
  }
}
// 全局设置文字提示样式
.el-tooltip__popper.is-dark {
  background: #fff;
  color: #333333;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
}
.el-tooltip__popper.is-dark::after {
  content: "▼";
  position: absolute;
  color: #fff;
  bottom: -10px;
  left: 50%;
}
.el-tooltip__popper .popper__arrow,
.el-tooltip__popper .popper__arrow::after {
  display: none;
}
// 设置评分星星大小
.el-rate {
  height: 30px;
  .el-rate__icon {
    font-size: 30px;
  }
}
// 分享样式
.social-share .social-share-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.wechat-qrcode {
  top: 32px !important;
}
.wechat-qrcode::after {
  top: -14px;
  border-color: transparent transparent #fff transparent !important;
}
// 预览图片最大80%
.el-image-viewer__canvas {
  img {
    max-width: 80% !important;
    max-height: 80% !important;
  }
}

// 移动端弹窗
.yd_box {
  width: 90vw;
}
.yd_box .el-message-box__input {
  padding-top: 0;
}
.yd_box .el-message-box__title {
  font-size: 15px;
}
.yd_box .el-message-box__btns {
  display: flex;
}
.yd_box .el-message-box__btns button {
  flex: 1;
}
.yd_box .el-textarea textarea {
  resize: none;
  height: 110px;
}
// loading自定义图片
// .el-loading-spinner .circular {
//   display: none;
// }
// .el-loading-spinner {
//   height: 300px;
//   background: url("/static/static/loading.gif");
//   background-size: 200px 100px;
//   background-repeat: no-repeat;
// }
.examination_boxs .page-content {
  width: 1450px !important;
}

.robot-content {
  .robot-view {
    // user-select: all;
    .text {
      // user-select: all;
      user-select: text;
    }
  }
}


.detail-box{
  .el-tabs__nav-wrap{
    padding: 0 11px;
  }

}
.questionSeq,
    .questionScore {
      min-width:24px;
    }

    .el-dialog{
      border-radius: 10px;
    }

    .graph-modal .mate-title{
      display:flex
    }





    .object-model-content {
  .threejs-wrapper {
    position: relative;
    width: 100%;
  }

  .threejs-container {
    width: 100%;
    height: 440px;
  }

  .fullscreen-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 100;
    
    &:hover {
      background: rgba(0, 0, 0, 0.8);
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }

    svg {
      pointer-events: none;
    }
  }

  .fullscreen-hint {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 12px 24px;
    border-radius: 4px;
    font-size: 14px;
    z-index: 10001;
    cursor: pointer;
    transition: all 0.3s ease;
    animation: fadeInDown 0.5s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.95);
    }
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
  
  .object3d-title {
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  .object3d-btn {
    background: #0000001f;
    display: flex;
    width: 100%;
    height: 400px;
    align-items: center;
    justify-content: center;
    
    span {
      border-radius: 8px;
      padding: 10px 15px;
      border: 1px solid #409EFF;
      background: #409EFF;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
    }
  }
}

.xml-object-modal-container.is-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9999;
  background: #000;

  > div {
    width: 100% !important;
    height: 100% !important;
  }

  .threejs-wrapper {
    width: 100% !important;
    height: 100% !important;
  }

  .threejs-container {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>